import { Component, ElementRef, Inject, OnInit, Renderer2 } from '@angular/core';
import { EventBus, EventBusBase } from '@skylab-angular-shared/core';
import { v4 as uuid } from 'uuid';
import { formContainerIdAttr } from '../utils/form';

//TODO: TO JEST DO WYWALENIA, TO JUŻ NIC NIE ROBI
@Component({
    selector: 'skl-form-container',
    templateUrl: './form-container.component.html'
})
export class FormContainerComponent implements OnInit {
    public constructor(
        protected elRef: ElementRef,
        protected renderer: Renderer2,
        @Inject(EventBus) protected eventBus: EventBusBase
    ) { }

    public ngOnInit(): void {
        const formId = uuid();
        const formIdAttr = formContainerIdAttr;
        this.renderer.setAttribute(this.elRef.nativeElement, formIdAttr, formId);
    }
}
